export const Luminor16Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <rect width="16" height="16" rx="2" fill="#4B163B" />
      <g clipPath="url(#clip0_1556_24515)">
        <path
          d="M10.9973 4.41785L9.58428 3.00586L8.17146 4.41785L9.58428 5.82967L10.9973 4.41785ZM7.00111 4.41785H5.00293V13.0044H10.9973V11.0085H7.00111V4.41785Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1556_24515">
          <rect width="6" height="10" fill="white" transform="translate(5 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};
